export default "__VITE_ASSET__C6u7tjom__"